module.exports = __webpack_public_path__ + "static/img/footer.c53f486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/footer.png
// module id = Fc6J
// module chunks = 18